import { useState, useEffect } from 'react';

const API = '/api';
const getToken  = () => localStorage.getItem('gaitabot_token');
const setToken  = t  => localStorage.setItem('gaitabot_token', t);
const clearToken= () => localStorage.removeItem('gaitabot_token');

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setError('');
    try {
      const r = await fetch(`${API}/auth/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error || 'Login failed');
      setToken(d.token);
      onLogin(d);
    } catch (err) { setError(err.message); }
    setLoading(false);
  };

  const s = {
    page:  { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#0d1117' },
    card:  { background:'#161b22', border:'1px solid #21262d', borderRadius:16, padding:40, width:360 },
    logo:  { display:'flex', alignItems:'center', gap:12, marginBottom:28, justifyContent:'center' },
    icon:  { width:44, height:44, borderRadius:11, background:'linear-gradient(135deg,#00d4aa,#3b82f6)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22 },
    lbl:   { display:'block', fontSize:11, fontWeight:600, color:'#00d4aa', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:6 },
    inp:   { width:'100%', background:'#0d1117', border:'1px solid #21262d', borderRadius:8, padding:'10px 12px', color:'#e2e8f0', fontSize:14, outline:'none', marginBottom:16, boxSizing:'border-box' },
    btn:   { width:'100%', padding:11, borderRadius:8, border:'none', background:'linear-gradient(135deg,#00d4aa,#3b82f6)', color:'white', fontWeight:700, fontSize:14, cursor:'pointer' },
    err:   { background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.3)', borderRadius:7, padding:'8px 12px', color:'#fca5a5', fontSize:12, marginBottom:16 },
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>
          <div style={s.icon}>🦿</div>
          <div>
            <div style={{fontWeight:700,fontSize:18}}>Gaita<span style={{color:'#00d4aa'}}>Bot</span></div>
            <div style={{fontSize:11,color:'#64748b'}}>3D Gait Analysis · Swinburne University</div>
          </div>
        </div>
        <form onSubmit={submit}>
          {error && <div style={s.err}>{error}</div>}
          <label style={s.lbl}>Username</label>
          <input style={s.inp} value={username} onChange={e=>setUsername(e.target.value)} autoComplete="username" required />
          <label style={s.lbl}>Password</label>
          <input style={s.inp} type="password" value={password} onChange={e=>setPassword(e.target.value)} autoComplete="current-password" required />
          <button style={s.btn} disabled={loading}>{loading?'Signing in...':'Sign In'}</button>
        </form>
      </div>
    </div>
  );
}

function AdminPanel({ onClose }) {
  const [users,   setUsers]   = useState([]);
  const [newUser, setNewUser] = useState({ username:'', password:'', reportLimit:5 });
  const [msg,     setMsg]     = useState('');
  const [err,     setErr]     = useState('');
  const [loading, setLoading] = useState(false);
  const authH = { 'Content-Type':'application/json', Authorization:`Bearer ${getToken()}` };

  const loadUsers = async () => {
    const r = await fetch(`${API}/auth/users`, { headers: authH });
    if (r.ok) setUsers(await r.json());
  };
  useEffect(() => { loadUsers(); }, []);

  const createUser = async (e) => {
    e.preventDefault(); setLoading(true); setMsg(''); setErr('');
    try {
      const r = await fetch(`${API}/auth/users`, { method:'POST', headers:authH, body:JSON.stringify(newUser) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setMsg(d.message);
      setNewUser({ username:'', password:'', reportLimit:5 });
      loadUsers();
    } catch(e) { setErr(e.message); }
    setLoading(false);
  };

  const updateLimit  = async (id, v) => { await fetch(`${API}/auth/users/${id}`,{method:'PATCH',headers:authH,body:JSON.stringify({reportLimit:parseInt(v)})}); loadUsers(); };
  const toggleActive = async (id, a) => { await fetch(`${API}/auth/users/${id}`,{method:'PATCH',headers:authH,body:JSON.stringify({active:!a})}); loadUsers(); };
  const resetUsage   = async (id)    => { await fetch(`${API}/auth/users/${id}`,{method:'PATCH',headers:authH,body:JSON.stringify({resetUsage:true})}); loadUsers(); };
  const deleteUser   = async (id, u) => { if(!window.confirm(`Delete user '${u}'?`))return; await fetch(`${API}/auth/users/${id}`,{method:'DELETE',headers:authH}); loadUsers(); };

  const s = {
    overlay:{ position:'fixed',inset:0,background:'rgba(0,0,0,0.7)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000 },
    modal:  { background:'#161b22',border:'1px solid #21262d',borderRadius:16,padding:28,width:'min(95vw,820px)',maxHeight:'90vh',overflowY:'auto' },
    inp:    { background:'#0d1117',border:'1px solid #21262d',borderRadius:7,padding:'7px 10px',color:'#e2e8f0',fontSize:13,outline:'none',width:'100%',boxSizing:'border-box' },
    btn:    (c)=>({ padding:'6px 14px',borderRadius:7,border:'none',background:`rgba(${c==='red'?'239,68,68':c==='orange'?'245,158,11':'0,212,170'},0.15)`,color:c==='red'?'#ef4444':c==='orange'?'#f59e0b':'#00d4aa',fontSize:12,cursor:'pointer',fontWeight:600 }),
    th:     { padding:'8px 10px',textAlign:'left',color:'#64748b',fontWeight:600,borderBottom:'1px solid #21262d',fontSize:11 },
    td:     { padding:'8px 10px',borderBottom:'1px solid #1e2633',color:'#e2e8f0',verticalAlign:'middle' },
  };

  return (
    <div style={s.overlay} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div style={s.modal}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
          <div style={{fontWeight:700,fontSize:16,color:'#e2e8f0'}}>👥 User Management</div>
          <button onClick={onClose} style={{background:'none',border:'none',color:'#64748b',fontSize:20,cursor:'pointer'}}>✕</button>
        </div>
        <div style={{background:'#0d1117',borderRadius:10,padding:16,marginBottom:20,border:'1px solid #21262d'}}>
          <div style={{fontWeight:600,color:'#00d4aa',fontSize:13,marginBottom:12}}>Create New User</div>
          {msg && <div style={{background:'rgba(0,212,170,0.08)',border:'1px solid rgba(0,212,170,0.2)',borderRadius:7,padding:'8px 12px',color:'#00d4aa',fontSize:12,marginBottom:12}}>{msg}</div>}
          {err && <div style={{background:'rgba(239,68,68,0.08)',border:'1px solid rgba(239,68,68,0.2)',borderRadius:7,padding:'8px 12px',color:'#ef4444',fontSize:12,marginBottom:12}}>{err}</div>}
          <form onSubmit={createUser}>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr auto',gap:10,alignItems:'end'}}>
              <div>
                <label style={{fontSize:10,fontWeight:700,color:'#00d4aa',textTransform:'uppercase',display:'block',marginBottom:5}}>Username</label>
                <input style={s.inp} value={newUser.username} onChange={e=>setNewUser(p=>({...p,username:e.target.value}))} required />
              </div>
              <div>
                <label style={{fontSize:10,fontWeight:700,color:'#00d4aa',textTransform:'uppercase',display:'block',marginBottom:5}}>Password</label>
                <input style={s.inp} type="password" value={newUser.password} onChange={e=>setNewUser(p=>({...p,password:e.target.value}))} required />
              </div>
              <div>
                <label style={{fontSize:10,fontWeight:700,color:'#00d4aa',textTransform:'uppercase',display:'block',marginBottom:5}}>Limit</label>
                <input style={{...s.inp,width:70}} type="number" min={1} max={999} value={newUser.reportLimit} onChange={e=>setNewUser(p=>({...p,reportLimit:parseInt(e.target.value)||5}))} />
              </div>
            </div>
            <button type="submit" disabled={loading} style={{marginTop:12,padding:'8px 20px',borderRadius:7,border:'none',background:'linear-gradient(135deg,#00d4aa,#3b82f6)',color:'white',fontWeight:700,fontSize:13,cursor:'pointer'}}>
              {loading?'Creating...':'Create User'}
            </button>
          </form>
        </div>
        <div style={{fontWeight:600,color:'#e2e8f0',fontSize:13,marginBottom:10}}>All Users ({users.length})</div>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
          <thead><tr>{['Username','Role','Used / Limit','Status','Last Login','Actions'].map(h=><th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {users.map(u=>(
              <tr key={u.id}>
                <td style={s.td}><strong>{u.username}</strong></td>
                <td style={s.td}><span style={{padding:'2px 8px',borderRadius:4,fontSize:11,fontWeight:600,background:u.role==='admin'?'rgba(0,212,170,0.15)':'rgba(59,130,246,0.15)',color:u.role==='admin'?'#00d4aa':'#3b82f6'}}>{u.role}</span></td>
                <td style={s.td}>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <span style={{color:u.reports_used>=u.report_limit&&u.role!=='admin'?'#ef4444':'#e2e8f0'}}>{u.reports_used} / {u.role==='admin'?'∞':u.report_limit}</span>
                    {u.role!=='admin'&&<input type="number" min={1} max={999} defaultValue={u.report_limit} style={{...s.inp,width:60,padding:'3px 6px'}} onBlur={e=>updateLimit(u.id,e.target.value)}/>}
                  </div>
                </td>
                <td style={s.td}><span style={{color:u.active?'#00d4aa':'#ef4444',fontWeight:600,fontSize:11}}>{u.active?'Active':'Disabled'}</span></td>
                <td style={s.td}><span style={{color:'#64748b',fontSize:11}}>{u.last_login?new Date(u.last_login).toLocaleDateString():'Never'}</span></td>
                <td style={s.td}>
                  {u.role!=='admin'&&<div style={{display:'flex',gap:6}}>
                    <button onClick={()=>toggleActive(u.id,u.active)} style={s.btn(u.active?'orange':'')}>{u.active?'Disable':'Enable'}</button>
                    <button onClick={()=>resetUsage(u.id)} style={s.btn()}>Reset</button>
                    <button onClick={()=>deleteUser(u.id,u.username)} style={s.btn('red')}>Delete</button>
                  </div>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function GaitaBotApp({ userData, onLogout }) {
  const [files,     setFiles]     = useState({ norm:null, kin:null, ts:null, gps:null });
  const [gender,    setGender]    = useState('Male');
  const [age,       setAge]       = useState('');
  const [name,      setName]      = useState('');
  const [busy,      setBusy]      = useState(false);
  const [status,    setStatus]    = useState('');
  const [error,     setError]     = useState('');
  const [done,      setDone]      = useState(false);
  const [remaining, setRemaining] = useState(userData.remaining);
  const [showAdmin, setShowAdmin] = useState(false);

  const isAdmin  = userData.role === 'admin';
  const setFile  = (k,f) => setFiles(p=>({...p,[k]:f}));
  const limitHit = !isAdmin && remaining <= 0;
  const canGo    = files.kin && files.ts && !busy && !limitHit;

  const reset = () => {
    setFiles({norm:null,kin:null,ts:null,gps:null});
    setDone(false); setError(''); setStatus('');
    document.querySelectorAll('input[type="file"]').forEach(el=>el.value='');
  };

  const generate = async () => {
    setBusy(true); setDone(false); setError(''); setStatus('Uploading CSV files...');
    try {
      const fd = new FormData();
      fd.append('gender',gender); fd.append('age',age); fd.append('patientName',name);
      if(files.norm) fd.append('normCSV',files.norm);
      if(files.kin)  fd.append('kinCSV',files.kin);
      if(files.ts)   fd.append('tsCSV',files.ts);
      if(files.gps)  fd.append('gpsCSV',files.gps);
      setStatus('Analysing kinematics and generating report...');
      const r = await fetch(`${API}/report/generate`,{method:'POST',headers:{Authorization:`Bearer ${getToken()}`},body:fd});
      if(!r.ok){
        const d = await r.json().catch(()=>({}));
        if(d.limitReached){setError('Report limit reached. Contact Dr Tirosh.');setRemaining(0);}
        else throw new Error(d.error||`Server error ${r.status}`);
        setBusy(false); setStatus(''); return;
      }
      setStatus('Preparing Word document...');
      const blob=await r.blob();
      const url=URL.createObjectURL(blob);
      const a=document.createElement('a');
      a.href=url; a.download=`GaitaBot_Report_${name||'Patient'}_${new Date().toISOString().slice(0,10)}.docx`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
      if(!isAdmin) setRemaining(r=>Math.max(0,r-1));
      setDone(true); setStatus('');
    } catch(err){setError(err.message);setStatus('');}
    setBusy(false);
  };

  const quotaColor = remaining<=1?'#ef4444':remaining<=2?'#f59e0b':'#00d4aa';
  const s = {
    page:  {minHeight:'100vh',background:'#0d1117',color:'#e2e8f0',fontFamily:"'Segoe UI',sans-serif"},
    hdr:   {display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 24px',borderBottom:'1px solid #21262d',background:'#161b22'},
    main:  {maxWidth:680,margin:'0 auto',padding:'28px 20px'},
    card:  {background:'#161b22',border:'1px solid #21262d',borderRadius:12,padding:20,marginBottom:14},
    lbl:   {fontSize:10,fontWeight:700,color:'#00d4aa',textTransform:'uppercase',letterSpacing:'0.08em',marginBottom:8,display:'block'},
    inp:   {width:'100%',background:'#0d1117',border:'1px solid #21262d',borderRadius:7,padding:'8px 10px',color:'#e2e8f0',fontSize:13,outline:'none',boxSizing:'border-box'},
    fRow:  {display:'flex',alignItems:'center',gap:10,marginBottom:8},
    fLbl:  ok=>({fontSize:11,color:ok?'#00d4aa':'#94a3b8',minWidth:130}),
    btn:   on=>({width:'100%',padding:10,borderRadius:8,border:'none',background:on?'linear-gradient(135deg,#00d4aa,#3b82f6)':'#21262d',color:on?'white':'#64748b',fontWeight:700,fontSize:13,cursor:on?'pointer':'not-allowed',marginTop:4}),
    btnSm: {width:'100%',padding:8,borderRadius:7,border:'1px solid #21262d',background:'transparent',color:'#64748b',fontSize:12,cursor:'pointer',marginTop:6},
  };

  const FileRow = ({label,fkey,required}) => (
    <div style={s.fRow}>
      <span style={s.fLbl(!!files[fkey])}>{required?'①':' ○'} {label} {files[fkey]?'✅':''}</span>
      <input type="file" accept=".csv" style={{fontSize:11,color:'#64748b',flex:1}} onChange={e=>setFile(fkey,e.target.files[0]||null)}/>
    </div>
  );

  return (
    <div style={s.page}>
      {showAdmin&&<AdminPanel onClose={()=>setShowAdmin(false)}/>}
      <div style={s.hdr}>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          <div style={{width:34,height:34,borderRadius:8,background:'linear-gradient(135deg,#00d4aa,#3b82f6)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:17}}>🦿</div>
          <div>
            <span style={{fontWeight:700,fontSize:16}}>Gaita<span style={{color:'#00d4aa'}}>Bot</span></span>
            <span style={{fontSize:11,color:'#64748b',marginLeft:8}}>3D Gait Analysis Report Generator</span>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:12}}>
          {!isAdmin&&(
            <div style={{padding:'4px 12px',borderRadius:20,background:`rgba(${remaining<=1?'239,68,68':remaining<=2?'245,158,11':'0,212,170'},0.12)`,border:`1px solid ${quotaColor}30`}}>
              <span style={{fontSize:12,color:quotaColor,fontWeight:600}}>{remaining} report{remaining!==1?'s':''} remaining</span>
            </div>
          )}
          {isAdmin&&(
            <button onClick={()=>setShowAdmin(true)} style={{padding:'5px 14px',borderRadius:7,border:'1px solid #21262d',background:'rgba(0,212,170,0.08)',color:'#00d4aa',fontSize:12,cursor:'pointer',fontWeight:600}}>
              👥 Manage Users
            </button>
          )}
          <span style={{fontSize:12,color:'#64748b'}}>👤 {userData.username}</span>
          <button onClick={onLogout} style={{padding:'5px 12px',borderRadius:6,border:'1px solid #21262d',background:'transparent',color:'#64748b',fontSize:11,cursor:'pointer'}}>Sign out</button>
        </div>
      </div>
      <div style={s.main}>
        {limitHit&&(
          <div style={{background:'rgba(239,68,68,0.08)',border:'1px solid rgba(239,68,68,0.3)',borderRadius:10,padding:'16px 20px',marginBottom:16,textAlign:'center'}}>
            <div style={{color:'#ef4444',fontWeight:700,fontSize:15,marginBottom:4}}>⚠️ Report limit reached</div>
            <div style={{color:'#fca5a5',fontSize:13}}>You have used all your allocated reports. Please contact Dr Tirosh to request additional reports.</div>
          </div>
        )}
        <div style={s.card}>
          <span style={s.lbl}>Patient Details</span>
          <div style={{marginBottom:10}}>
            <label style={{fontSize:11,color:'#64748b',display:'block',marginBottom:4}}>Patient Name (optional)</label>
            <input style={s.inp} value={name} onChange={e=>setName(e.target.value)} placeholder="e.g. J. Smith"/>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
            <div>
              <label style={{fontSize:11,color:'#64748b',display:'block',marginBottom:4}}>Age</label>
              <input style={s.inp} value={age} onChange={e=>setAge(e.target.value)} placeholder="e.g. 72"/>
            </div>
            <div>
              <label style={{fontSize:11,color:'#64748b',display:'block',marginBottom:4}}>Gender</label>
              <select style={s.inp} value={gender} onChange={e=>setGender(e.target.value)}><option>Male</option><option>Female</option></select>
            </div>
          </div>
        </div>
        <div style={s.card}>
          <span style={s.lbl}>Upload CSV Files</span>
          <FileRow label="Normative data"  fkey="norm" required={false}/>
          <div style={{fontSize:10,color:'#3b3f4a',marginBottom:8,marginLeft:140}}>optional — uses embedded lab norms if not uploaded</div>
          <FileRow label="Kinematics ①"    fkey="kin"  required={true}/>
          <FileRow label="Tempo-Spatial ①" fkey="ts"   required={true}/>
          <FileRow label="GPS data"         fkey="gps"  required={false}/>
          <div style={{fontSize:10,color:'#3b3f4a',marginTop:4,marginLeft:140}}>optional — calculated from kinematics if not uploaded</div>
          <div style={{fontSize:10,color:'#64748b',marginTop:8}}>① = required</div>
        </div>
        <button style={s.btn(canGo)} onClick={generate} disabled={!canGo}>
          {busy?'⏳ Generating report...':limitHit?'⛔ Report limit reached':'📄 Generate & Download Word Report'}
        </button>
        {done&&<button style={s.btnSm} onClick={reset}>🔄 New Report</button>}
        {status&&<div style={{background:'rgba(0,212,170,0.06)',border:'1px solid rgba(0,212,170,0.18)',borderRadius:7,padding:'8px 12px',color:'#00d4aa',fontSize:12,marginTop:10}}>⏳ {status}</div>}
        {error&&<div style={{background:'rgba(239,68,68,0.08)',border:'1px solid rgba(239,68,68,0.25)',borderRadius:8,padding:'10px 14px',color:'#fca5a5',fontSize:12,marginTop:10}}>⚠️ {error}</div>}
        {done&&!error&&(
          <div style={{background:'rgba(0,212,170,0.08)',border:'1px solid rgba(0,212,170,0.25)',borderRadius:8,padding:'14px 18px',marginTop:10}}>
            <div style={{color:'#00d4aa',fontWeight:700,marginBottom:4}}>✅ Report downloaded successfully</div>
            <div style={{fontSize:12,color:'#64748b'}}>Open the Word document to review and edit.</div>
          </div>
        )}
        {!busy&&!done&&(
          <div style={{marginTop:24,padding:16,background:'#161b22',borderRadius:10,border:'1px solid #21262d'}}>
            <div style={{fontSize:11,fontWeight:700,color:'#64748b',marginBottom:8,textTransform:'uppercase',letterSpacing:'0.06em'}}>Report Contents</div>
            <div style={{fontSize:12,color:'#64748b',lineHeight:2}}>
              📄 Page 1 — Patient details + Summary Findings + Recommendations<br/>
              📊 Page 2 — GPS bar chart + data table + literature comparison<br/>
              📈 Page 3 — Kinematic graphs (12) + Kinematic Features list<br/>
              ⏱️ Page 4 — Tempo-Spatial illustration + Gait Cycle Parameters
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function App() {
  const [userData, setUserData] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!token) { setChecking(false); return; }
    fetch(`${API}/auth/verify`, { headers:{ Authorization:`Bearer ${token}` } })
      .then(r=>r.ok?r.json():null)
      .then(d=>{ if(d?.valid) setUserData({...d.user}); })
      .catch(()=>{})
      .finally(()=>setChecking(false));
  }, []);

  const handleLogin  = d => setUserData({ username:d.username, role:d.role, remaining:d.remaining, reportLimit:d.reportLimit });
  const handleLogout = () => { clearToken(); setUserData(null); };

  if (checking) return (
    <div style={{minHeight:'100vh',background:'#0d1117',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{color:'#00d4aa',fontSize:14}}>Loading GaitaBot...</div>
    </div>
  );

  if (!userData) return <LoginPage onLogin={handleLogin}/>;
  return <GaitaBotApp userData={userData} onLogout={handleLogout}/>;
}
